import React, { useEffect, useState } from 'react';
import Lottie from 'react-lottie';

import animationDataFinish from '../../lotties/finish-process-document.json';
import animationDataMerge from '../../lotties/merge-documentos.json';
import ProcessoSoWatch from './ProcessoSoWatch';

const HtmlBase = ({children}) => (
  <>
    <div className='col-8'>
      <div className='card'>
        <div className='card-body'>{children}</div>
      </div>
    </div>
  </>
);

const TRACK = {
  etapas: {
    etapa1: {
      nome:   'Inicializando processamento de montagem;',
      status: 'processando'
    },
    etapa2: {nome: 'Gerando capa;', status: 'aguardando'},
    etapa3: {nome: 'Baixando documentos do processo;', status: 'aguardando'},
    etapa4: {
      nome:   'Convertendo documentos editáveis da visualização;',
      status: 'aguardando'
    },
    etapa5: {nome: 'Gerando resumo das movimentações do processo;', status: 'aguardando'},
    etapa6: {
      nome:   'Montagem do processo;',
      status: 'aguardando'
    },
    etapa7: {nome: 'Processo montado num único arquivo!', status: 'aguardando'}
  },
  status: ['processando', 'aguardando', 'sucesso', 'erro']
};

const Content = ({
                   handleInitProcessamento,
                   handleCurrentProcessamento,
                   loading,
                   userId
                 }) => {
  const [currentProcessamento, setCurrentProcessamento] = useState(null);

  // EFFECT TO CHANGE CURRENT PROCESSAMENTO
  useEffect(() => {
    if (handleCurrentProcessamento) {
      setCurrentProcessamento(handleCurrentProcessamento);
    }
  }, [handleCurrentProcessamento]);

  // HANDLE INIT MATERIALIZAR
  const handleMaterializar = () => {
    handleInitProcessamento(true);
  };

  // RETURN LOADING
  if (loading) {
    return (
      <HtmlBase>
        <div className='text-center'>
          <div className='fa-10x text-primary'>
            <i className='fas fa-cog fa-spin' />
          </div>
        </div>
      </HtmlBase>
    );
  }

  // RETURN INICIAR PROCESSAMENTO
  if (!currentProcessamento) {
    return (
      <HtmlBase>
        <div className='text-center'>
          <div className='alert alert-warning shadow-sm' role='alert'>
            <h4 className='alert-heading'>ATENÇÃO!</h4>
            <p>
              Esse processo possui vários sub-processos apensados ou
              incorporados.
            </p>
            <p>
              Realizar a materialização deste processo pode demorar, pois ele
              depende da materialização dos seus sub-processos, na sua ordem,
              conforme a listagem ao lado.
            </p>

            <p>Para prosseguir, clique no botão abaixo.</p>
            <hr />
            <button
              className='btn btn-warning btn-block text-white'
              onClick={handleMaterializar}
            >
              clique aqui para iniciar a materialização
            </button>
          </div>
        </div>
      </HtmlBase>
    );
  }

  // RETURN ERROR
  if (currentProcessamento?.status === 'error') {
    return (
      <HtmlBase>
        <div className='text-center'>
          <div className='fa-8x text-danger animate__animated animate__zoomIn animate__infinite animate__slow'>
            <i className='fas fa-exclamation-triangle' />
          </div>
          <h6 className='text-muted'>erro ao realizar processamento</h6>
        </div>
      </HtmlBase>
    );
  }

  // RETURN EM PROCESSAMENTO
  if (currentProcessamento?.status === 'em_processamento') {
    return (
      <HtmlBase>
        <div className='text-center'>
          <div className='fa-8x text-warning animate__animated animate__zoomIn animate__infinite animate__slow'>
            <i className='fas fa-stopwatch' />
          </div>
          <h6 className='text-muted'>
            Atenção, este processo já se encontra em processamento no servidor,
            aguarde um pouco até a finalização do processamento.
          </h6>
        </div>
      </HtmlBase>
    );
  }

  // RETURN CURRENT PROCESSAMENTO
  if (currentProcessamento?.status === 'processando') {
    const numeroAno = currentProcessamento.numero.replace('/', '_');
    const track     = JSON.parse(JSON.stringify(TRACK));
    return (
      <HtmlBase>
        <div className='animate__animated animate__fadeIn'>
          <ProcessoSoWatch
            track={track}
            userId={userId}
            processoAno={numeroAno}
          />
        </div>
      </HtmlBase>
    );
  }

  // RETURN CURRENT PROCESSAMENTO MERGE
  if (currentProcessamento?.status === 'processando_merge') {
    return (
      <HtmlBase>
        <div className='text-center'>
          <div className='animate__animated animate__fadeIn'>
            <Lottie
              options={{
                autoplay:      true,
                animationData: animationDataMerge
              }}
              height={300}
              width={350}
            />
          </div>
          <h6 className='text-warning'>UNINDO PROCESSOS</h6>
        </div>
      </HtmlBase>
    );
  }

  // RETURN CURRENT PROCESSAMENTO MERGE
  if (currentProcessamento?.status === 'finish') {
    return (
      <HtmlBase>
        <div className='text-center'>
          <div className='animate__animated animate__fadeIn'>
            <Lottie
              options={{
                loop:          false,
                autoplay:      true,
                animationData: animationDataFinish
              }}
              height={300}
              width={350}
            />
          </div>
        </div>
      </HtmlBase>
    );
  }

  // RETURN NOTHING
  return <></>;
};

export default React.memo(Content);
